module.exports = __webpack_public_path__ + "static/media/illustration-performance-evaluation.868b3661.svg";